<app-sidebar-header
  [isExpanded]="isExpanded()"
  [toggleSidebar]="toggleSidebar"
></app-sidebar-header>
<app-workspace-manager
  [isExpanded]="isExpanded()"
  [toggleSidebar]="toggleSidebar"
></app-workspace-manager>
<!-- <app-api-access-card
  [isExpanded]="isExpanded()"
></app-api-access-card> -->
<app-account-menu 
  [isExpanded]="isExpanded()" 
  [toggleSidebar]="toggleSidebar"
></app-account-menu>
